import { 
    BASE_URL, 
    Data,
    DEFAULT_ERROR_MESSAGE
} from 'core/utilities';

export enum HTTPMethod
{
    GET    = 'GET',
    PUT    = 'PUT',
    POST   = 'POST',
    PATCH  = 'PATCH',
    HEAD   = 'HEAD',
    DELETE = 'DELETE'
}

export interface Result
{
    success : boolean;
    reply?  : Data;
    error?  : string;
}

enum HTTPSuccessCode
{
    OK         = 200,
    CREATED    = 201,
    ACCEPTED   = 202,
    NO_CONTENT = 204,
}

export const isSuccessCode = (code : number) : boolean =>
{
    return Object.values(HTTPSuccessCode).includes(code);
};

export const query = async (route : string, headers : Data = {}) : Promise<Result> =>
{
    const options = {
        method : HTTPMethod.GET,
        headers : {
            'Content-Type' : 'application/json',
            ...headers
        }
    };

    try
    {
        const response = await fetch(`${BASE_URL}/${route}`, options);
        const reply    = await response.json();

        return {
            success : true,
            reply
        };
    }
    catch (error)
    {
        return {
            success : false,
            error   : DEFAULT_ERROR_MESSAGE
        };
    }
};

export const mutate = async (route : string, payload : Data = {}, headers : Data = {}, method : HTTPMethod = HTTPMethod.POST) : Promise<Result> =>
{
    const options = {
        method,
        headers : {
            'Content-Type' : 'application/json',
            ...headers
        },
        body : JSON.stringify(payload)
    };

    try
    {
        const response = await fetch(`${BASE_URL}/${route}`, options);
        const reply    = await response.json();

        return {
            success : isSuccessCode(response.status),
            reply
        };
    }
    catch (error)
    {
        return {
            success : false,
            error   : DEFAULT_ERROR_MESSAGE
        };
    }
};